import { Text, useTheme } from '@ui-kitten/components';
import * as ActionScreens from '../../../screens/main/actions';
import { AddActionsTabParamList } from 'src/core/types/RootNavigationParamList';
import React from 'react';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import { useIsLightColorScheme } from 'src/core/hooks/useIsLightColorScheme';

const ActionProtocolTab = () => {
  const th = useTheme();
  const TabTop = createMaterialTopTabNavigator<AddActionsTabParamList>();

  const isLightTheme = useIsLightColorScheme();

  return (
    <TabTop.Navigator
      screenOptions={{
        tabBarLabel: ({ focused, children }) => (
          <Text
            category="p2"
            status={focused ? 'primary' : 'basic'}
            style={{ color: th[`color-${focused ? 'primary-500' : 'basic-600'}`] }}>
            {children}
          </Text>
        ),
        tabBarContentContainerStyle: {
          backgroundColor: th[`color-basic-${isLightTheme ? 100 : 1000}`],
          marginBottom: 1
        },
        tabBarIndicatorStyle: { backgroundColor: th['color-primary-500'] },
        tabBarIndicatorContainerStyle: { backgroundColor: th[`color-basic-${isLightTheme ? 100 : 1000}`] }
      }}>
      <TabTop.Screen
        options={{
          lazy: true
        }}
        name="Active Protocols"
        component={ActionScreens.ActiveProtocols}
      />
      <TabTop.Screen options={{ lazy: true }} name="Active Actions" component={ActionScreens.TodayActionsScreen} />
    </TabTop.Navigator>
  );
};

export default ActionProtocolTab;
